import Api from './Api'

export default {
    async create(parameters) {
        const api = await Api()
        return api.post('new-package', parameters)
    },
    async show(parameters) {
        const api = await Api()
        return api.post('packages', parameters)
    },
    async createActivity(parameters) {
        const api = await Api()
        return api.post('new-activity', parameters)
    },
    async showActivities(parameters) {
        const api = await Api()
        return api.post('activities', parameters)
    },
    async getProcesses(parameters) {
        const api = await Api()
        return api.post('processes', parameters)
    },
    async moveActivityUp(parameters) {
        const api = await Api()
        return api.post('activity/move-up', parameters)
    },
    async moveActivityDown(parameters) {
        const api = await Api()
        return api.post('activity/move-down', parameters)
    },
    async deleteActivity(parameters) {
        const api = await Api()
        return api.post('activity/delete', parameters)
    },
    async updateActivity(parameters) {
        const api = await Api()
        return api.post('activity/update', parameters)
    },
    async delete(parameters) {
        const api = await Api()
        return api.post('package/delete', parameters)
    },
    async update(parameters) {
        const api = await Api()
        return api.post('package/update', parameters)
    },
    async saveSchedule(parameters) {
        const api = await Api()
        return api.post('package/save-schedule', parameters)
    },
    async getDetails(parameters) {
        const api = await Api()
        return api.post('package', parameters)
    },
    async run(parameters) {
        const api = await Api()
        return api.post('package/run', parameters)
    },
    async getHistory(parameters) {
        const api = await Api()
        return api.post('package/history', parameters)
    },
    async getAllHistory(parameters){
        const api = await Api()
        return api.post("package/all-history",parameters)
    },
    async getFilteredHistoryDetails(idList, filter, currentUser, dateRange){
        window.open(
            `${process.env.VUE_APP_SERVER_SSL_FLAG ? "https" : "http"}://${
              process.env.VUE_APP_SERVER_HOST_NAME
            }:${process.env.VUE_APP_SERVER_PORT}/jobHistory/download?idList=${JSON.stringify(idList)}&filter=${JSON.stringify(filter)}&currentUserId=${JSON.stringify(currentUser)}&dateRange=${JSON.stringify(dateRange)}`,
            "_blank"
          );
        
    },
    async getHistoryActivities(parameters) {
        const api = await Api()
        return api.post('activities/history', parameters)
    },
    async getLog(parameters) {
        const api = await Api()
        return api.post('package/log', parameters)
    },
    async getActivityLog(parameters) {
        const api = await Api()
        return api.post('activity/log', parameters)
    },
    async getHistoryResults() {
        const api = await Api()
        return api.post('package/completed-histories')
    }
}
